export var shape = {
    borderRadius: 2,
};
export default shape;
//# sourceMappingURL=shape.js.map